export const messages = {
  en: {
    seckill: {
      productNamePlaceholder: 'Enter product name',
      seckill: {
        title: 'Seckill Products',
        shop: 'Shop',
        product: 'Product',
        hours: 'Seckill Hours',
        duration: 'Duration Hours',
        limit: 'Purchase Limit',
        single: 'Single Purchase',
        seckillPrice: 'Seckill Price',
        originalPrice: 'Original Price',
        stock: 'Stock',
        status: 'Status',
        timeRange: 'Time Range'
      },
      seckillOrder: {
        title: 'Seckill Orders',
        shop: 'Shop',
        id: 'Order ID',
        image: 'Product Image',
        name: 'Product Name',
        buyer: 'Buyer',
        quantity: 'Quantity',
        price: 'Seckill Price',
        time: 'Purchase Time',
        status: 'Status',
        endTime: 'Deadline'
      }
    }
  },
  zh: {
    seckill: {
      productNamePlaceholder: '请输入商品名称',
      seckill: {
        title: '秒杀商品',
        shop: '店铺',
        product: '产品名称',
        hours: '秒杀小时',
        duration: '持续小时',
        limit: '有效期内购买',
        single: '一次购买数量',
        seckillPrice: '秒杀金额',
        originalPrice: '单买金额',
        stock: '限量',
        status: '状态',
        timeRange: '有效期'
      },
      seckillOrder: {
        title: '秒杀订单',
        shop: '店铺',
        id: '订单ID',
        image: '商品图片',
        name: '商品名称',
        buyer: '购买者',
        quantity: '购买数量',
        price: '秒杀金额',
        time: '购买时间',
        status: '状态',
        endTime: '截止时间'
      }
    }
  }
}